import { FC, useCallback } from "react";
import { Button, Stack } from "@mui/material";
import { useAppAbility } from "@/services/permissions";
import { useAppSelector } from "@/store/hooks";
import { activeProviderConnectionCurrentStepSelector } from "@/store/provider-connections/selectors/active-connection/activeProviderConnectionCurrentStepSelector";

interface SnowflakeConnectionDrawerActionsProps {
  onCancel(): void;
  onStepChange(index: number): void;
  disabled: boolean;
}

export const SnowflakeConnectionDrawerActions: FC<
  SnowflakeConnectionDrawerActionsProps
> = ({ onCancel, onStepChange, disabled }) => {
  const { cannot } = useAppAbility();
  const canNotCreateIntegration = cannot("create", "integration");

  const activeStep = useAppSelector(
    activeProviderConnectionCurrentStepSelector,
  );

  const nextStepHandler = useCallback(() => {
    onStepChange(activeStep + 1);
  }, [onStepChange, activeStep]);

  const prevStepHandler = useCallback(() => {
    onStepChange(activeStep - 1);
  }, [onStepChange, activeStep]);

  return (
    <Stack direction="row" justifyContent="space-between">
      {activeStep === 1 && <Button onClick={prevStepHandler}>Back</Button>}
      <Stack
        direction="row"
        spacing={2}
        px={2}
        justifyContent="end"
        width="100%"
      >
        <Button onClick={onCancel} color="tertiary">
          Cancel
        </Button>
        <Button
          onClick={nextStepHandler}
          disabled={canNotCreateIntegration || disabled}
          variant="contained"
        >
          Next
        </Button>
      </Stack>
    </Stack>
  );
};
